import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomeScreen() {
  const navigate = useNavigate();

  return (
    <div className="home-screen">
      {/* ── Hero banner ────────────────────────────────────── */}
      <div className="hero-banner">
        <div className="hero-content">
          <div className="hero-badge">
            <span>🗳️</span>
            2026 சட்டமன்றத் தேர்தல் | 2026 Legislative Assembly Election
          </div>

          <h1 className="hero-title">
            Tamil Nadu Election Commission<br />
            <span>Biometric Voting Portal</span>
          </h1>

          <p className="hero-subtitle">
            Voting is conducted exclusively through the biometric hardware kiosk.
            Use the physical buttons on the device to select your candidate and
            authenticate with your fingerprint.
          </p>

          <div className="hero-features">
            <div className="hero-feature">🔒 Fingerprint Auth</div>
            <div className="hero-feature">⛓️ Blockchain Secured</div>
            <div className="hero-feature">🛡️ Tamper Detection</div>
            <div className="hero-feature">📡 Real-time Results</div>
          </div>

          {/* Hardware-only notice — no web voting button */}
          <div style={{
            background: 'rgba(255,255,255,0.10)',
            border: '1px solid rgba(255,255,255,0.25)',
            borderRadius: 10,
            padding: '14px 24px',
            color: 'rgba(255,255,255,0.85)',
            fontSize: '0.88rem',
            maxWidth: 460,
            lineHeight: 1.7,
          }}>
            🖥️ &nbsp;<strong>Voting is hardware-only.</strong> Please proceed to the
            biometric kiosk and use the <strong>UP / DOWN / SELECT</strong> buttons
            to cast your vote. This website is for live results and administration only.
          </div>

          <div className="hero-actions">
            <button
              className="btn btn-orange btn-lg"
              onClick={() => navigate('/results')}
            >
              📊 &nbsp;View Live Results
            </button>
          </div>
        </div>
      </div>

      {/* ── Info cards ─────────────────────────────────────── */}
      <div className="home-info-row">
        <div className="info-card">
          <div className="info-card-icon">🖲️</div>
          <div className="info-card-title">Hardware Buttons</div>
          <div className="info-card-desc">
            Use UP / DOWN to scroll candidates and SELECT to confirm.
            Voting happens entirely on the physical kiosk device.
          </div>
        </div>

        <div className="info-card">
          <div className="info-card-icon">👆</div>
          <div className="info-card-title">Biometric Authentication</div>
          <div className="info-card-desc">
            Your fingerprint uniquely identifies you. Only registered
            voters enrolled on the sensor can cast a ballot.
          </div>
        </div>

        <div className="info-card">
          <div className="info-card-icon">⛓️</div>
          <div className="info-card-title">Blockchain Record</div>
          <div className="info-card-desc">
            Every vote is cryptographically chained. Any tampering is
            immediately detected and flagged in the audit log.
          </div>
        </div>

        <div className="info-card">
          <div className="info-card-icon">🚨</div>
          <div className="info-card-title">Tamper Alerts</div>
          <div className="info-card-desc">
            Double-vote attempts are logged as TAMPERED and displayed
            publicly in the Live Results dashboard in real time.
          </div>
        </div>
      </div>

      {/* ── Voting steps (hardware flow) ───────────────────── */}
      <div className="screen" style={{ paddingTop: 0 }}>
        <div className="section-title">எவ்வாறு வாக்களிப்பது | How to Vote (Hardware Kiosk)</div>
        <p className="section-subtitle">Four steps on the physical voting device</p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 14, marginBottom: 32 }}>
          {[
            { step: '1', icon: '🔴', title: 'Press SELECT',       desc: 'Press the SELECT button on the kiosk to begin the voting session.' },
            { step: '2', icon: '🔼', title: 'Choose Candidate',   desc: 'Use UP / DOWN buttons to scroll through candidates. Press SELECT to confirm.' },
            { step: '3', icon: '👆', title: 'Fingerprint Scan',   desc: 'Place your registered finger on the biometric sensor when prompted.' },
            { step: '4', icon: '✅', title: 'Vote Confirmed',     desc: 'The LCD displays your voted candidate. Result appears live on this site.' },
          ].map(s => (
            <div key={s.step} className="card" style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: 20 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{
                  background: 'var(--tnec-navy)', color: '#fff',
                  width: 26, height: 26, borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '0.78rem', fontWeight: 800, flexShrink: 0,
                }}>{s.step}</span>
                <span style={{ fontSize: '1.3rem' }}>{s.icon}</span>
              </div>
              <div style={{ fontWeight: 700, color: 'var(--tnec-navy)', fontSize: '0.9rem' }}>{s.title}</div>
              <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', lineHeight: 1.6 }}>{s.desc}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button className="btn btn-primary btn-lg" onClick={() => navigate('/results')}>
            📊 View Live Election Results →
          </button>
        </div>
      </div>
    </div>
  );
}
